import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_charge_for_inkind_benefits_at_or_below_cost'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_charge_for_inkind_benefits_at_or_below_cost',
  name: 'Does the facility charge for in-kind benefits at or below cost?',
  description:
    'The intent of this question is to understand if in-kind benefits are always provided for free or at the actual cost of goods. \r\r\n\r\r\nThe idea is that facilities are not "making money" by offering in-kind benefits. \r\r\n\r\r\nFor example, if facility offers workers food on-site at the facility, but charges for the food at a cost that is above the cost incurred by the facility (meaning, the initial purchase and preparation costs), answer No.\r\r\n\r\r\nIf no costs are charged at all, answer Yes.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-22--4',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9600,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
